import type { FaireProductEntity } from "../../entity_types/product";

export const p_znf2cd2csw: FaireProductEntity = {
  token: "p_znf2cd2csw",
  type: "product",
  name: "Ghost Pumpkin Head Colorful Led Light-up Wand",
  brandToken: "b_1e67dn411w",
  brandName: "Cap Zone",
  imageUrl:
    "https://cdn.faire.com/fastly/c0505d34c7d827b22cf9d70194ac2f6de2407b121931a22b425019a384d49733.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5369f6f72ed308065fe66430496aba17366e01420ff7f2d061aca93641acf6cd.jpeg",
    "https://cdn.faire.com/fastly/e683d0c38edc7dfb65df8d8471cf64ec404d5c8191afa321bab3178aa3f8a24f.jpeg",
    "https://cdn.faire.com/fastly/d77f99d342babeb9b54d1ecb7c65bcc9eb829f6c9713a627a9aba3cfa73e43ba.jpeg",
    "https://cdn.faire.com/fastly/06208d4013791ccee24f09def721a508e4b1b74cc2576371ea213a930b7d3f78.jpeg",
    "https://cdn.faire.com/fastly/2d60617505baea89bd6821b756e5963a7ec8801ca3d6727fbcf617e15f52d8bd.jpeg",
    "https://cdn.faire.com/fastly/834d8d9cee9ae7f4a78cb10e2960b0744e3d0118b66d8c4c957530c881a2b5ee.jpeg",
    "https://cdn.faire.com/fastly/15475b0efebb936cc8d6847c44aa65bcf04d52ee2383ec7fa928f3200af01eb1.jpeg",
    "https://cdn.faire.com/fastly/e7ce1ece311db3971bbe69474f67def826674f42c1fe15749ae6bd76d408dfbc.jpeg",
    "https://cdn.faire.com/fastly/b87b603700a9926dd83848eba4368edd7b18dc10f4838e91e8da9f7dad9b1219.jpeg",
    "https://cdn.faire.com/fastly/9cdb038770ce93920e94ef17322637a4823a963e9627822982f8159208be9fc3.jpeg",
    "https://cdn.faire.com/fastly/2b907b33f991744764771ffa86e1593607fd4903fed8b808704d5cb09a28eaa4.jpeg",
  ],
  priceDollars: 1.5,
  description:
    'Ghost Pumpkin Head Colorful Rainbow LED Light-Up Novelty Stick Wand\n\n• Wand Dimensions: 14.25" * 0.75" * 0.75"\n• Charm Dimensions: 2.5" * 2.5" * 2.5"\n• Assorted Design (6-Pumpkin, 6-Ghost, May Vary)\n• 3 Level LED operates on inner non-replaceable battery push button switch. Please remove the pull-tab before use.\n• 100% Plastic\n• CA Prop 65 Advisory\n\n• Packaging Details: Individually packed in clear OPP bag, then wrapped as whole in clear poly bag.\n\n• Perfect for Trick or Treat indoor and outdoor spooky Halloween decorations and costume parties.',
  tags: [],
  msrpDollars: 3,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:44.246Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
